import React from 'react';

// Base shimmer block
export function Skeleton({ className = '' }: { className?: string }) {
    return <div className={`skeleton rounded-sm ${className}`} />;
}

function HeaderSkeleton({ titleWidth }: { titleWidth: string }) {
    return (
        <div className="page-container pt-14 md:pt-20 pb-2 flex flex-col gap-4" aria-hidden>
            <Skeleton className={`h-12 ${titleWidth}`} />
            <Skeleton className="h-5 w-80 max-w-full" />
        </div>
    );
}

// Projects list: header + trail entries
export function ProjectListSkeleton() {
    return (
        <div aria-busy="true" aria-label="Loading projects">
            <HeaderSkeleton titleWidth="w-56" />
            <div className="page-container pt-12 pb-20 flex flex-col gap-16" aria-hidden>
                {[...Array(3)].map((_, i) => (
                    <div key={i} className="pl-8 md:pl-12 grid gap-5 md:grid-cols-[12rem_1fr] md:gap-12">
                        <div className="flex flex-col gap-2">
                            <Skeleton className="h-7 w-16" />
                            <Skeleton className="h-4 w-28" />
                        </div>
                        <div className="flex flex-col gap-3">
                            <Skeleton className="aspect-[2/1] w-full max-w-[44rem] mb-2" />
                            <Skeleton className="h-7 w-2/3 max-w-sm" />
                            <Skeleton className="h-4 w-full max-w-[40rem]" />
                            <div className="flex gap-2"><Skeleton className="h-6 w-16" /><Skeleton className="h-6 w-20" /></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

// Blog list rows
export function BlogRowSkeleton() {
    return (
        <div aria-busy="true" aria-label="Loading posts">
            <HeaderSkeleton titleWidth="w-32" />
            <div className="page-container pt-12 pb-20 flex flex-col gap-10" aria-hidden>
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="flex flex-col gap-3 max-w-[42rem]">
                        <Skeleton className="h-4 w-24" />
                        <Skeleton className="h-6 w-2/3" />
                        <Skeleton className="h-4 w-full" />
                        <Skeleton className="h-4 w-4/5" />
                    </div>
                ))}
            </div>
        </div>
    );
}

// Detail page (project or blog)
export function DetailSkeleton() {
    return (
        <div aria-busy="true" aria-label="Loading">
            <div className="page-container pt-10 md:pt-14 pb-10 flex flex-col gap-4" aria-hidden>
                <Skeleton className="h-4 w-24 mb-4" />
                <Skeleton className="h-12 w-1/2" />
                <Skeleton className="h-5 w-full max-w-xl" />
            </div>
            <div className="page-container pb-12" aria-hidden>
                <Skeleton className="w-full h-64 sm:h-80" />
            </div>
            <div className="page-container pb-20 grid gap-10 md:grid-cols-[12rem_1fr] md:gap-12" aria-hidden>
                <div className="flex flex-col gap-4">
                    <Skeleton className="h-4 w-20" />
                    <Skeleton className="h-4 w-28" />
                    <Skeleton className="h-4 w-24" />
                </div>
                <div className="flex flex-col gap-3 max-w-[42rem]">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-5/6" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-3/4" />
                </div>
            </div>
        </div>
    );
}

// Small inline skeleton for ProjectBlogList
export function BlogItemSkeleton() {
    return (
        <div className="flex flex-col gap-4" aria-hidden>
            <Skeleton className="h-6 w-40" />
            {[...Array(2)].map((_, i) => (
                <div key={i} className="flex flex-col gap-2">
                    <Skeleton className="h-3 w-24" />
                    <Skeleton className="h-5 w-64 max-w-full" />
                </div>
            ))}
        </div>
    );
}
